const onLogout = [];
let user, loginTarget
const LOCAL_API_ORIGIN = process.env.REACT_APP_LOCAL_API_ORIGIN || 'http://127.0.0.1:8080'

function getUserKey(){
    return `user_details:${getApiOrigin()}`
}

function getApiOrigin(){
    const {hostname, host, protocol} = window.location
    if (/^(localhost|127\.0\.0\.1)$/.test(hostname)) {
        return LOCAL_API_ORIGIN
    }
    return `${protocol}//${host}`
}

function getHost(){
    return new URL(getApiOrigin()).host
}

export function inDevMode(){
    return /localhost|127.0.0.1|localtest.sonasafe.co.nz|portal-dev.sonasafe.co.nz/.test(window.location.host)
}

function getUrl(){
    return `${getApiOrigin()}/api/`
}

function getWebSocketOrigin(){
    const apiOrigin = new URL(getApiOrigin())
    const wsProtocol = apiOrigin.protocol === 'https:' ? 'wss:' : 'ws:'
    return `${wsProtocol}//${apiOrigin.host}`
}

function hasTextResponse(xhr){
    return !xhr.responseType || xhr.responseType === 'text'
}

function parseResponse(xhr){
    if (!hasTextResponse(xhr)){
        return xhr.response
    }
    const type = xhr.getResponseHeader('Content-Type')
    if (/application\/json/.test(type)){
        return JSON.parse(xhr.responseText)
    }
    else if (/text\//.test(type)){
        return xhr.responseText
    }
    else{
        return xhr.response
    }
}

function isAuthenticationFailure(status, responseText){
    if (status !== 403 && status !== 401){
        return false
    }
    return /Missing authorization header|Bad token|Unknown user|ExpiredSignature|InvalidSignature|InvalidToken|Invalid issuer/i
        .test(responseText || '')
}

function rejectResponse(xhr, responseText, nay){
    if (isAuthenticationFailure(xhr.status, responseText)){
        logout()
        window.location.hash = "/login"
        return
    }
    nay(responseText || xhr.statusText)
}

function call(method, url, token, decorator, data){
    return new Promise(function(yay, nay) {
        const xhr = new XMLHttpRequest();
        xhr.addEventListener('load', () => {
            const {status} = xhr
            if (status >= 200 && status < 300){
                yay(parseResponse(xhr))
                return
            }
            console.log("Got error " + xhr.statusText)
            if (!hasTextResponse(xhr) && xhr.response && typeof xhr.response.text === 'function'){
                xhr.response.text()
                    .then(responseText => rejectResponse(xhr, responseText, nay))
                    .catch(() => nay(xhr.statusText))
                return
            }
            try {
                const body = parseResponse(xhr)
                const responseText = body && body.message
                    ? body.message
                    : typeof body === 'string' ? body : xhr.statusText
                rejectResponse(xhr, responseText, nay)
            } catch (e) {
                nay(xhr.statusText)
            }
        });
        xhr.addEventListener('error', nay);
        xhr.withCredentials = true;
        xhr.open(method, url);
        if (token){
            xhr.setRequestHeader('Authorization', `Bearer ${token}`);
        }
        if (decorator){
            decorator(xhr)
        }
        if (data){
            xhr.setRequestHeader('Content-Type', 'application/json')
            xhr.send(JSON.stringify(data));
        }
        else {
            xhr.send();
        }
    });
}

function downloadCsv(url, token){
    return call("GET", url, token)
}

function getUser(){
    return user || (user = (() => {
        const raw = localStorage.getItem(getUserKey())
        return raw ? JSON.parse(raw) : null
    })())
}

function getToken(){
    const u = getUser();
    return u ? u.token : null;
}

function logout(){
    localStorage.removeItem(getUserKey())
    onLogout.forEach(list => list())
    user = null;
}

export default {
    getUser: getUser,
    get isAdmin(){
        const user = getUser();
        return user && user.admin;
    },
    get host(){
        return getHost()
    },
    get wsOrigin(){
        return getWebSocketOrigin()
    },
    addLogoutListener: function(list){
        onLogout.push(list);
    },
    setLoginTarget: function(path){
        if (!user){
            loginTarget = path
        }
    },
    login: function(email, password){
        return call('POST', `${getUrl()}signin`, null, null,{
            email: email, password: password
        }).then(reply => {
            user = reply
            localStorage.setItem(getUserKey(), JSON.stringify(reply))
            if (!user.admin){
                document.location.href = "/dashboard"
            }
            return user
        }).catch((e) => {
            logout();
            throw e
        })
    },
    logout: logout,
    post: function(uri, data){
        return call('POST', getUrl() + uri, getToken(), null, data)
    },
    put: function(uri, data){
        return call('PUT', getUrl() + uri, getToken(), null, data)
    },
    get: function(uri, token) {
        if (token === undefined){
            token = getToken()
        }
        uri = /^https?:\/\//.test(uri) ? uri : getUrl() + uri;
        return call('GET', uri, token)
    },
    del: function(uri){
        return call('DELETE', getUrl() + uri, getToken())
    },
    setToken: function(token){
        user.token = token;
        user.admin = false;
        localStorage.setItem(getUserKey(), JSON.stringify(user))
    },
    getCsv(uri, filename){
        return downloadCsv(getUrl() + uri, getToken()).then(csv => {
            const a = document.createElement('a');
            a.download = filename;
            a.href = "data:text/csv;charset=utf-8," + window.encodeURIComponent(csv);
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a)
            return true
        })
    },
    getBinary(uri){
        return call('GET', getUrl() + uri, getToken(), xhr => xhr.responseType = 'blob')
    },
    decodeQrCode(qrCode) {
        return this.get(`qr/decode/${qrCode}`)
    },
    translateDeviceUrl(url){
        return new Promise((yay, nay) => {
            const match = /^https:\/\/device.sonasafe.co.nz\/(.+)/.exec(url)
            if (!match) {
                nay(url)
            }
            const qr = match[1]
            this.decodeQrCode(qr).then(id => yay({
                id: id, qr: qr
            }))
        })
    }
}
